import {Component, inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ApplicationService} from '../services/application.service';

@Component({
    selector: 'app-header-panel',
    templateUrl: './header-panel.component.html',
    styleUrls: ['./header-panel.component.scss'],
    standalone: false
})
export class HeaderPanelComponent implements OnChanges {
  @Input() field: string;
  http = inject(HttpClient);
  loaded = false;
  title: string;
  text: string;

  constructor(public appService: ApplicationService) {
  }

  getHelpText(field: string): void {
    this.loaded = false;
    this.appService.getHelp(field).subscribe((help: any) => {
      this.title = help.help_label;
      this.text = help.help_text;
      this.loaded = true;
    });
  }
  ngOnChanges({field}: SimpleChanges): void {
    if (field?.currentValue) {
      this.getHelpText(field.currentValue);
    }
  }

}
